import c from "./extends3.mjs";
import * as D from "react";
import { useUtils as ee, useLocaleText as te, useLocalizationContext as ne } from "./useUtils.mjs";
import { getSectionsBoundaries as se, splitFormatIntoSections as E, validateSections as N, getDateFromDateSections as oe, mergeDateIntoReferenceDate as B, addPositionPropertiesToSections as ae } from "./useField.utils.mjs";
import { useValueWithTimezone as le } from "./useValueWithTimezone.mjs";
import { getSectionTypeGranularity as re } from "./getDefaultReferenceDate.mjs";
import ce from "./useTheme.mjs";
import ie from "./useControlled.mjs";
const ve = (b) => {
  const t = ee(), y = te(), L = ne(), g = ce().direction === "rtl", {
    valueManager: i,
    fieldValueManager: m,
    valueType: P,
    validator: q,
    internalProps: R,
    internalProps: {
      value: O,
      defaultValue: U,
      referenceDate: W,
      onChange: k,
      format: h,
      formatDensity: w = "dense",
      selectedSections: G,
      onSelectedSectionsChange: z,
      shouldRespectLeadingZeros: A = !1,
      timezone: Q
    }
  } = b, {
    timezone: u,
    value: V,
    handleValueChange: Z
  } = le({
    timezone: Q,
    value: O,
    defaultValue: U,
    onChange: k,
    valueManager: i
  }), _ = D.useMemo(() => se(t, u), [t, u]), v = D.useCallback((e, n = null) => m.getSectionsFromValue(t, e, n, g, (o) => E(t, u, y, h, o, w, A, g)), [m, h, y, g, A, t, w, u]), j = D.useMemo(() => m.getValueStrFromSections(v(i.emptyValue), g), [m, v, i.emptyValue, g]), [s, x] = D.useState(() => {
    const e = v(V);
    N(e, P);
    const n = {
      sections: e,
      value: V,
      referenceValue: i.emptyValue,
      tempValueStrAndroid: null
    }, o = re(e), a = i.getInitialReferenceValue({
      referenceDate: W,
      value: V,
      utils: t,
      props: R,
      granularity: o,
      timezone: u
    });
    return c({}, n, {
      referenceValue: a
    });
  }), [p, H] = ie({
    controlled: G,
    default: null,
    name: "useField",
    state: "selectedSectionIndexes"
  }), F = (e) => {
    H(e), z?.(e), x((n) => c({}, n, {
      selectedSectionQuery: null
    }));
  }, r = D.useMemo(() => {
    if (p == null)
      return null;
    if (p === "all")
      return {
        startIndex: 0,
        endIndex: s.sections.length - 1,
        shouldSelectBoundarySelectors: !0
      };
    if (typeof p == "number")
      return {
        startIndex: p,
        endIndex: p
      };
    if (typeof p == "string") {
      const e = s.sections.findIndex((n) => n.type === p);
      return {
        startIndex: e,
        endIndex: e
      };
    }
    return p;
  }, [p, s.sections]), I = ({
    value: e,
    referenceValue: n,
    sections: o
  }) => {
    if (x((d) => c({}, d, {
      sections: o,
      value: e,
      referenceValue: n,
      tempValueStrAndroid: null
    })), i.areValuesEqual(t, s.value, e))
      return;
    const a = {
      validationError: q({
        adapter: L,
        value: e,
        props: c({}, R, {
          value: e,
          timezone: u
        })
      })
    };
    Z(e, a);
  }, C = (e, n) => {
    const o = [...s.sections];
    return o[e] = c({}, o[e], {
      value: n,
      modified: !0
    }), ae(o, g);
  }, J = () => {
    I({
      value: i.emptyValue,
      referenceValue: s.referenceValue,
      sections: v(i.emptyValue)
    });
  }, K = () => {
    if (r == null)
      return;
    const e = s.sections[r.startIndex], n = m.getActiveDateManager(t, s, e), a = n.getSections(s.sections).filter((f) => f.value !== "").length === (e.value === "" ? 0 : 1), d = C(r.startIndex, ""), S = a ? null : t.date(/* @__PURE__ */ new Date("")), l = n.getNewValuesFromNewActiveDate(S);
    (S != null && !t.isValid(S)) != (n.date != null && !t.isValid(n.date)) ? I(c({}, l, {
      sections: d
    })) : x((f) => c({}, f, l, {
      sections: d,
      tempValueStrAndroid: null
    }));
  }, X = (e) => {
    const n = (d, S) => {
      const l = t.parse(d, h);
      if (l == null || !t.isValid(l))
        return null;
      const f = E(t, u, y, h, l, w, A, g);
      return B(t, u, l, f, S, !1);
    }, o = m.parseValueStr(e, s.referenceValue, n), a = m.updateReferenceValue(t, o, s.referenceValue);
    I({
      value: o,
      referenceValue: a,
      sections: v(o, s.sections)
    });
  }, Y = ({
    activeSection: e,
    newSectionValue: n,
    shouldGoToNextSection: o
  }) => {
    o && r && r.startIndex < s.sections.length - 1 ? F(r.startIndex + 1) : r && r.startIndex !== r.endIndex && F(r.startIndex);
    const a = m.getActiveDateManager(t, s, e), d = C(r.startIndex, n), S = a.getSections(d), l = oe(t, S);
    let f, T;
    if (l != null && t.isValid(l)) {
      const M = B(t, u, l, S, a.referenceDate, !0);
      f = a.getNewValuesFromNewActiveDate(M), T = !0;
    } else
      f = a.getNewValuesFromNewActiveDate(l), T = (l != null && !t.isValid(l)) != (a.date != null && !t.isValid(a.date));
    return T ? I(c({}, f, {
      sections: d
    })) : x((M) => c({}, M, f, {
      sections: d,
      tempValueStrAndroid: null
    }));
  }, $ = (e) => x((n) => c({}, n, {
    tempValueStrAndroid: e
  }));
  return D.useEffect(() => {
    const e = v(s.value);
    N(e, P), x((n) => c({}, n, {
      sections: e
    }));
  }, [h, t.locale]), D.useEffect(() => {
    let e = !1;
    i.areValuesEqual(t, s.value, V) ? e = i.getTimezone(t, s.value) !== i.getTimezone(t, V) : e = !0, e && x((n) => c({}, n, {
      value: V,
      referenceValue: m.updateReferenceValue(t, V, n.referenceValue),
      sections: v(V)
    }));
  }, [V]), {
    state: s,
    selectedSectionIndexes: r,
    setSelectedSections: F,
    clearValue: J,
    clearActiveSection: K,
    updateSectionValue: Y,
    updateValueFromValueStr: X,
    setTempAndroidValueStr: $,
    sectionsValueBoundaries: _,
    placeholder: j,
    timezone: u
  };
};
export {
  ve as useFieldState
};
//# sourceMappingURL=useFieldState.mjs.map
